export default "__VITE_ASSET__BKjohFAF__"